<template>
    <div>
        <div
            class="fast-buy flex-justify-around"
            :style="{
                bottom: product.type.id === 6 && !showAddToCart ? '6.7rem !important' : '3.3rem',
            }"
            @mouseleave="showAddToCart = true"
            v-if="!productAddedToCart.status"
            :class="showAddToCart ? 'first-color' : 'second-color'"
            @click.prevent="showAddToCart ? (selectedSize = sizes[0]) : null"
        >
            <div v-if="showAddToCart" class="text-uppercase" @mouseenter="handleMouseEnter">
                Adicionar à sacola
            </div>

            <div
                v-else-if="availableModelings && availableModelings.length > 0 && !selectedModeling"
                v-for="modeling in availableModelings"
                class="select-add-to-cart"
                @click.prevent="setModeling(modeling)"
            >
                <span>{{ modeling.url }}</span>
            </div>

            <div v-else-if="!selectedModeling && originalModelingsCount > 0">
                <span>Selecione outra Cor</span>
            </div>

            <div
                v-else-if="availableSizes && availableSizes.length > 0 && !selectedSize"
                v-for="size in availableSizes"
                class="select-add-to-cart"
                @click.prevent="onSizeClick(size)"
            >
                <span
                    :style="{
                        ':hover': {
                            transform:
                                product.type.id === 6
                                    ? 'scale(1.1) !important'
                                    : 'scale(1.2) !important',
                        },
                        'font-size': product.type.id === 6 ? '15px !important' : '18px !important',
                    }"
                    >{{ size.size_name }}</span
                >
            </div>

            <div v-else-if="!selectedSize">
                <span>Selecione outra Cor</span>
            </div>

            <div
                class="d-flex flex-align-center"
                v-else-if="loadingCart"
                :style="{ marginTop: product.type.id === 6 ? '3.3rem' : '0' }"
            >
                <Spinner small />
            </div>
        </div>

        <div
            v-else-if="productAddedToCart.status && !loadingCart"
            class="fast-buy d-flex flex-justify-around text-white"
            :style="{
                'background-color': productAddedToCart.bg_color,
                bottom: '3.3rem',
            }"
        >
            <div class="text-uppercase">
                {{ productAddedToCart.text }}
            </div>
        </div>
    </div>
</template>
<script>
    import BaseVariations from './BaseVariations.vue';
    import ProductVariations from './ProductVariations.vue';
    import Spinner from '@bit/chicorei.chicomponents.feedback.spinner';

    export default {
        name: 'ProductListAddToCartDesktop',
        components: { ProductVariations, Spinner },

        extends: BaseVariations,

        data() {
            return {
                showAddToCart: true,
                productAddedToCart: {
                    text: null,
                    bg_color: '#000000',
                    status: false,
                },
            };
        },

        computed: {
            availableSizes() {
                if (!this.sizes) return [];
                return this.sizes.filter((size) => this.shopMode && size.has_any === true);
            },

            availableModelings() {
                if (!this.modelings) return [];
                return this.modelings.filter(
                    (modelings) => this.shopMode && modelings.has_any === true
                );
            },
        },

        watch: {
            selectedSize: {
                handler(to) {
                    if (to) {
                        this.showAddToCart = false;
                        this.reportToTagManager();
                        this.addToCart(false);
                    }
                },
            },
        },

        methods: {
            handleMouseEnter() {
                this.showAddToCart = this.variations.length <= 1;

                if (
                    this.availableModelings.length === 1 &&
                    this.originalModelingsCount === 1 &&
                    this.product.is_clothing
                ) {
                    this.setModeling(this.availableModelings[0]);
                } else {
                    this.setModeling(null);
                }

                this.setSize(null);
            },
        },
    };
</script>
